import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'src/app/providers/toastService/toast.service';
import { ApiService } from 'src/app/providers/apiService/api.service';
import * as moment from 'moment';
import { AccessService } from 'src/app/providers/access/access.service';
@Component({
  selector: 'app-add-provider',
  templateUrl: './add-provider.page.html',
  styleUrls: ['./add-provider.page.scss'],
})
export class AddProviderPage implements OnInit {
  providerForm: FormGroup;
  minDate: any;
  todaysDate: any;
  dateIssued: any;
  endDate: any;
  displayEndDate: boolean=false;
   // eslint-disable-next-line max-len
   successMassage= 'We have received your request.<br/><br/> Our registrations team will prepare the necessary paperwork and contact you within two business days.<br/><br/> If you would like to talk to us about your request please call us on <a href="tel:1300 809 484">1300 809 484</a>';
   errorMessages = {
    providerNumber: [{ type: 'required', message: 'Enter a valid provider number.' }],
    addressLineOne: [{ type: 'required', message: ' Enter a valid address' }],
    // addressLineTwo: [{ type: 'required', message: ' Enter a valid address' }],
    suburb: [{ type: 'required', message: ' Enter suburb' }],
    state: [{ type: 'required', message: ' Select state value' }],
    postCode: [{ type: 'required', message: 'Enter a valid postcode' }],
    locationType: [{ type: 'required', message: 'Select location type' }],
    // dateIssued: [{ type: 'required', message: 'Select issued date' }],
    // endDate: [{ type: 'required', message: ' Choose Date Schedule' }]
  };
   constructor(private navCtrl: NavController,
    public formBuilder: FormBuilder,
    public apiService: ApiService,
    public toastService: ToastService,
    public accessService: AccessService,
) {
      this.providerForm = this.formBuilder.group({
        providerNumber: ['', Validators.required],
        addressLineOne: ['', Validators.required],
        addressLineTwo: [''],
        suburb: ['', Validators.required],
        state: ['', Validators.required],
        postCode: ['', [Validators.required,Validators.minLength(6)]],
        locationType: ['', Validators.required],
        dateIssued: [moment().format()],
        endDate: [''],
        comments: [''],
      });
    }

  ngOnInit() {
    this.minDate = moment().subtract(1, 'days').format();
    this.todaysDate = moment().format();
    this.dateIssued = moment().format();
    this.endDate = moment().format();
  }
  ionViewDidEnter() {
    this.accessService.resetLogoutTimer();
  }
  async onSubmitForm() {
    //console.log(this.providerForm.controls.dateIssued.value);
    if (this.providerForm.valid) {
      await this.numberleading();
      this.toastService.presentLoading();
      this.apiService.post('add-provider', this.providerForm.value).subscribe(
        (res) => {
          this.toastService.dismissLoading();
          if (res.error === false) {
            //console.log('Form Value:: ', this.providerForm.value);
            this.navCtrl.navigateForward(['/confirmation-page'], {
              queryParams: {
                state : this.successMassage,
                hasAddButton:false
              },
          });
          }
        },
        (err) => {
          this.toastService.dismissLoading();
          this.toastService.presentToast('error','Something went wrong.');
          //console.log(err);
        }
      );
    } else {
      //console.log('form', this.providerForm.value);
      this.providerForm.markAllAsTouched();
    }
  }
  toggleEndDate(e) {
    this.displayEndDate = false;
    if (!e.target.checked)
    {
      this.displayEndDate = true;
    }    
  }
 numberleading() {
    let str = '' + this.providerForm.get('providerNumber').value;
    while (str.length < 8) {
        str = '0' + str;
    }
   return this.providerForm.controls.providerNumber.setValue(str);
  }

  updateDateIssued($event) {
    this.dateIssued = $event.detail.value;
  }

  updateEndDate($event) {
    this.endDate = $event.detail.value;
  }
}
